/**
 * Export `cleanValue` util.
 */

export function cleanValue(value: string) {
  return value?.replace(/[-\s]/g, '');
}
